<template lang="html">
  <div class="flex flex-col">
    <HomeRootTiles />
    <NewSection />
    <HomeContentNotes />
  </div>
</template>

<script setup lang="ts">
import HomeContentNotes from '#Content/components/Home/HomeContentNotes.vue'
import HomeRootTiles from '#Products/components/Catalog/HomeRootTiles.vue'
import NewSection from '#Products/components/Info/NewSection.vue'
import type { CategoryDto } from '#Products/models/Pim/CategoryDto'

definePageMeta({
  name: 'ProductsIndex',
  layoutContainer: 'full',
})

const route = useRoute()
const { routing } = useProducts()
const { all } = await useCategories()

// Legacy numeric category URL (/:id) → 301 to /catalog/:slug;
// unknown root path → hard 404 (no soft-404 into catalog)
const legacyCategoryId = computed(() => route.params.category as string | undefined)
if (legacyCategoryId.value) {
  const category = all.value?.[legacyCategoryId.value] as CategoryDto | undefined
  if (!category) {
    throw createError({ statusCode: 404, statusMessage: 'Page not found' })
  }
  await navigateTo(routing.getCatalog(category).route, {
    redirectCode: 301,
    replace: true,
  })
}

// Home discovery shell — default storefront meta (no category breadcrumb JSON-LD)
useCategorySeo(computed(() => undefined), all)
</script>
